import React, { useCallback, useEffect, useRef, useState } from 'react';
import { ChevronLeftIcon, ChevronRightIcon } from 'lucide-react';
import { vaultPreviews } from '../data/vaultPreviews';
export function VaultPreviews() {
  const trackRef = useRef<HTMLUListElement>(null);
  const [active, setActive] = useState(0);
  const scrollToIndex = useCallback((index: number) => {
    const track = trackRef.current;
    if (!track) return;
    const item = track.children[index] as HTMLElement | undefined;
    if (!item) return;
    track.scrollTo({
      left: item.offsetLeft - track.offsetLeft,
      behavior: 'smooth'
    });
  }, []);
  useEffect(() => {
    const track = trackRef.current;
    if (!track) return;
    const onScroll = () => {
      const children = Array.from(track.children) as HTMLElement[];
      const center = track.scrollLeft + track.clientWidth / 2;
      let closest = 0;
      let min = Infinity;
      children.forEach((child, i) => {
        const childCenter = child.offsetLeft - track.offsetLeft + child.clientWidth / 2;
        const distance = Math.abs(childCenter - center);
        if (distance < min) {
          min = distance;
          closest = i;
        }
      });
      setActive(closest);
    };
    track.addEventListener('scroll', onScroll, {
      passive: true
    });
    return () => track.removeEventListener('scroll', onScroll);
  }, []);
  const last = vaultPreviews.length - 1;
  return <section aria-label="Inside pages preview" className="mt-14" data-id="element-219" data-mp="ymfshmr8wz23">
      <h3 className="text-center font-display text-2xl font-black text-plum sm:text-3xl" data-id="element-220" data-mp="tn37l7jxq225">
        👀 Take A Look Inside The Vault
      </h3>

      <div className="relative mt-8" data-id="element-221" data-mp="omyqbfb7d3av">
        <ul ref={trackRef} className="flex snap-x snap-mandatory gap-4 overflow-x-auto scroll-smooth px-1 pb-4 [scrollbar-width:none] [&::-webkit-scrollbar]:hidden" data-id="element-222" data-mp="oq2z6pzm4n7v">
          {vaultPreviews.map((p, i) => <li key={p.id} className="w-[74%] shrink-0 snap-center sm:w-[46%] lg:w-[31%]" data-id="element-223" data-mp="35c44ies4j3co" data-mpi={i}>
              <div className="overflow-hidden rounded-2xl border border-grape/20 bg-cream shadow-[0_18px_40px_-26px_rgba(13,47,51,0.55)]" data-id="element-224" data-mp="36v42x3ni4jxb">
                <img src={p.src} alt={p.alt} loading={i < 2 ? 'eager' : 'lazy'} decoding="async" width={1080} height={1350} className="aspect-[4/5] w-full bg-cream object-cover object-top" data-id="element-225" data-mp="3bqjetq1y85r3" />
              </div>
            </li>)}
        </ul>

        <div className="mt-2 flex items-center justify-center gap-4" data-id="element-226" data-mp="2svur0g6bwbz5">
          <button type="button" onClick={() => scrollToIndex(Math.max(0, active - 1))} disabled={active === 0} aria-label="Previous page preview" className="flex h-10 w-10 items-center justify-center rounded-full border border-grape/25 bg-white text-grape transition-[background-color,opacity] duration-150 ease-out hover:bg-lilac-soft disabled:opacity-35" data-id="element-227" data-mp="2e6oux12sf1vh">
            <ChevronLeftIcon className="h-5 w-5" data-id="element-228" data-mp="1qjl5tnojgnfs" />
          </button>

          <div className="flex items-center gap-2" data-id="element-229" data-mp="1lk8b6grfec2n">
            {vaultPreviews.map((p, i) => <button key={p.id} type="button" onClick={() => scrollToIndex(i)} aria-label={`Go to preview ${i + 1}`} aria-current={i === active} className={i === active ? 'h-2 w-6 rounded-full bg-grape transition-[width,background-color] duration-200 ease-out' : 'h-2 w-2 rounded-full bg-grape/25 transition-[width,background-color] duration-200 ease-out'} data-id="element-230" data-mp="1zjzumx0poko1" data-mpi={i} />)}
          </div>

          <button type="button" onClick={() => scrollToIndex(Math.min(last, active + 1))} disabled={active === last} aria-label="Next page preview" className="flex h-10 w-10 items-center justify-center rounded-full border border-grape/25 bg-white text-grape transition-[background-color,opacity] duration-150 ease-out hover:bg-lilac-soft disabled:opacity-35" data-id="element-231" data-mp="2s85hbpbbsjqi">
            <ChevronRightIcon className="h-5 w-5" data-id="element-232" data-mp="3g37ei2ym22q3" />
          </button>
        </div>
      </div>
    </section>;
}